export default __webpack_public_path__ + "static/media/art_2.5eac0a3b.mp4";